import React from 'react';
import { formatCurrency } from '@/utils/formatters';
import { DEFAULT_CATEGORIES } from '@/constants';

function statusColor(percent) {
  if (percent >= 100) return '#B71C1C';
  if (percent >= 80)  return '#F57F17';
  return '#2E7D32';
}

function statusLabel(status) {
  switch (status) {
    case 'danger':  return '🔴 Over budget';
    case 'warning': return '🟡 80%+ used';
    default:        return '✓ On track';
  }
}

export default function CategoryProgressBars({ categoryStatus, categories }) {
  // Prefer live context categories; fall back to defaults
  const catList = (categories && categories.length) ? categories : DEFAULT_CATEGORIES;
  const CAT_MAP = Object.fromEntries(catList.map(c => [c.id, c]));

  const entries = Object.entries(categoryStatus || {});
  if (!entries.length) {
    return (
      <p className="text-xs text-gray-400 text-center py-4">
        No budgets set for this month.
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-3 px-3 pb-1">
      {entries.map(([catId, { budget, spent, percent, status }]) => {
        const cat   = CAT_MAP[catId];
        const label = cat ? `${cat.emoji} ${cat.label}` : catId;
        const color = statusColor(percent);
        const pct   = Math.min(percent, 100);

        return (
          <div key={catId}>
            <div className="flex justify-between items-center mb-1">
              <span className="text-xs font-semibold text-gray-700">{label}</span>
              <span className="text-xs text-gray-400">
                {formatCurrency(spent)} / {formatCurrency(budget)}
              </span>
            </div>
            <div className="progress-bar-track">
              <div
                className="h-full rounded-full transition-all duration-700"
                style={{ width: `${pct}%`, backgroundColor: color }}
                role="progressbar"
                aria-valuenow={Math.round(percent)}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-label={`${label} budget usage`}
              />
            </div>
            <span className="text-xs font-medium mt-0.5 block"
              style={{ color }}>
              {statusLabel(status)}
            </span>
          </div>
        );
      })}
    </div>
  );
}
